import React from "react";
import { Loader2 } from "lucide-react";

interface ActionButtonProps {
    onClick: () => void;
    icon?: React.ReactNode;
    label: string;
    mobileLabel?: string;
    disabled?: boolean;
    isLoading?: boolean;
    variant?: "primary" | "ghost";
    type?: "button" | "submit";
}

const ActionButton: React.FC<ActionButtonProps> = ({
    onClick,
    icon,
    label,
    mobileLabel,
    disabled = false,
    isLoading = false,
    variant = "primary",
    type = "button",
}) => {
    const base =
        "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed";

    const variants = {
        primary: "bg-blue-600 hover:bg-blue-700 text-white",
        ghost: "bg-[#1a1a1a] border border-[#2d2d2d] text-gray-300 hover:bg-[#222222] hover:text-white",
    };

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || isLoading}
            className={`${base} ${variants[variant]}`}
        >
            {isLoading ? (
                <Loader2 className="w-3.5 h-3.5 animate-spin" />
            ) : icon ? (
                <span className="w-3.5 h-3.5 flex items-center justify-center">{icon}</span>
            ) : null}
            {mobileLabel ? (
                <>
                    <span className="hidden sm:inline">{label}</span>
                    <span className="sm:hidden">{mobileLabel}</span>
                </>
            ) : (
                label
            )}
        </button>
    );
};

export default ActionButton;
